module.exports = __webpack_public_path__ + "img/1507432318.935f0963.jpg";